import React from 'react';
import EmbedJS from 'embed-js';

import config from '../config/dev';

let RichMediaContainer = React.createClass({
  getInitialState () {
    return {
      embedContent: ''
    }
  },

  defaultProps: {
    content: '',
    onHeightChange: () => {}
  },

  propTypes: {
    content: React.PropTypes.string,
    onHeightChange: React.PropTypes.func
  },

  componentWillMount () {
    this.initiateEmbedder();
  },

  componentDidMount () {
    this.performEmbed();
    this.updateHeightDifference();
  },

  componentDidUpdate () {
    this.updateHeightDifference();
  },

  componentWillReceiveProps () {
    this.initiateEmbedder();
    this.performEmbed();
  },

  shouldComponentUpdate (nextProps) {
    if (nextProps.isHidden) return false;

    return true;
  },

  initiateEmbedder () {
    if (this.props.content && this.props.content.length > 0) {
      let embedder = new EmbedJS({
        input: this.props.content,
        googleAuthKey: config.googleApiKey,
        inlineEmbed: ['youtube'],
        excludeEmbed: ['gist'],
        videoWidth: '100%',
        videoDetails: false,
        linkOptions: {target: '_blank'}
      });
      this.setState({embedder});
    }
  },

  updateHeightDifference () {
    let imageEls = this.refs.mediaContainer.querySelectorAll('img');

    // wait for image load.
    if (imageEls.length > 0 && !this.state.hasImageLoaded) {
      let el = imageEls[0];
      el.style.display = 'none';

      el.onload = () => {
        this.updateHeightDifference();
        el.style.display = '';
        this.setState({hasImageLoaded: true});
      }

      return;
    }

    let currentHeight = this.refs.mediaContainer.offsetHeight;

    if (currentHeight === 0) return;

    if (this.state.prevHeight) {
      if (currentHeight !== this.state.prevHeight) {
        let difference = currentHeight - this.state.prevHeight;

        this.props.onHeightChange(difference, this.state.prevHeight, currentHeight);
        this.setState({prevHeight: currentHeight});
      }
    }
    else {
      this.setState({prevHeight: currentHeight});
    }
  },

  performEmbed () {
    if (this.state.embedder) {
      this.state.embedder.text((embedContent) => this.setState({embedContent}));
    }
  },

  richContentMarkup () {
    return {__html: this.state.embedContent}
  },

  render () {
    if (this.state.embedContent.length > 0) {
      return (
        <div ref='mediaContainer' className='rich-media-embed' dangerouslySetInnerHTML={this.richContentMarkup()} />
      )
    }
    else {
      return (
        <div ref='mediaContainer' className='rich-media-embed'>
          {this.props.content}
        </div>
      )
    }
  }
});

// function createContainer (Component) {
//   let ComponentFactory = React.createFactory(Component);
//
//   // Higher order component here.
// }

export default RichMediaContainer;



/** WEBPACK FOOTER **
 ** ./modules/shared/containers/rich_media_container.js
 **/